<footer class="footerBgSecMain">
  <div class="mainContainer">
    <div class="footerMobilemainAll">
      <div class="mobileViewFooter" dir="ltr">
        <a>


          <div class="headerltr">
            <img src="../../assets/images/infinthra-whitetext-logo.svg" style="max-width: 170px" alt="logo">
          </div>
          <div class="headerrtl">
            <img src="../../assets/images/footer-bottom-logo.svg" style="max-width: 170px" alt="logo">
          </div>
        </a>
        <div class="languageDropDownDiv">
          <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ lang == "ar" ? "AR" : "EN" }}
            </button>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" (click)="setLang('en')" [ngClass]="lang == 'en' ? 'highlight' : ''">EN</a>
              </li>
              <li>
                <a class="dropdown-item" (click)="setLang('ar')" [ngClass]="lang == 'ar' ? 'highlight' : ''">AR</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Subscription Section -->
      <div class="subScribeLetterDiv">
        <h3>{{ "footer.subscribe.heading" | translate }}</h3>
        <div class="subScrbeLetterDivBgWhite" dir="ltr">
          <form *ngIf="!isLargeScreen" name="footerForm" [formGroup]="form" (ngSubmit)="handleSubmit($event)">
            <input type="text" formControlName="honeypot" tabindex="-1" autocomplete="off" aria-hidden="true"
              style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;" />
            <input name="email" type="text" [placeholder]="'footer.subscribe.placeholder' | translate"
              formControlName="email" />
            <button [type]="this.form.valid ? 'submit' : 'button'" aria-label="label">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M3.99959 12.7192L18.1663 12.7192" stroke="white" stroke-width="1.66667"
                  stroke-linecap="round" />
                <path d="M12.8807 18.8379L19 12.7186L12.9053 6.62385" stroke="white" stroke-width="1.66667"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </form>

          <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
            <small class="error">{{ getErrorMessage("email") }}</small>
          </div>
        </div>
      </div>

      <!-- Success Modal (Custom) -->
      <!-- Success Modal -->
      <div class="custom-modal-mob " *ngIf="showSuccessModal">
        <div class="custom-modal-content-mob">
          <img src="../../assets/images/footer-success.svg" alt="Success" class="success-icon-mob " />
          <div class="modal-text">
            <h2 class="mob-h2">{{ "footer.subscribe.successModal.title" | translate }}</h2>
            <p class="subcontent-mob">{{ "footer.subscribe.successModal.message" | translate }}</p>
          </div>
        </div>
      </div>


      <ul class="socialMediaNav">
        <li>
          <a target="_blank" href="https://www.facebook.com/infithra " rel="noopener noreferrer"
            aria-label="Facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a>
        </li>
        <li>
          <a target="_blank" href="https://www.instagram.com/infithra " rel="noopener noreferrer"
            aria-label="Instagram"><img alt="img" src="../../assets/images/instagrame-icon.svg" /></a>
        </li>
        <li>
          <a target="_blank" href="https://www.linkedin.com/company/infithra/ " rel="noopener noreferrer"><i
              class="fa fa-linkedin" aria-hidden="true"></i></a>
        </li>
        <li>
          <a target="_blank" href="https://www.youtube.com/@infithra" rel="noopener noreferrer"
            aria-label="Youtube"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="13" viewBox="0 0 19 13"
              fill="none">
              <path
                d="M18.1658 1.96396C17.951 1.23303 17.3562 0.659768 16.5901 0.457123C15.1794 0.0957204 9.50854 0.0957205 9.50854 0.0957205C9.50854 0.0957205 3.84841 0.0870511 2.42306 0.457123C1.66091 0.66031 1.06329 1.23303 0.850707 1.96396C0.583277 3.34943 0.45041 4.75169 0.45663 6.16046C0.453803 7.56001 0.586104 8.96011 0.850707 10.3369C1.06329 11.0678 1.66091 11.6411 2.42306 11.847C3.83371 12.2084 9.50854 12.2084 9.50854 12.2084C9.50854 12.2084 15.1653 12.2084 16.5901 11.847C17.3562 11.6411 17.951 11.0684 18.1658 10.3369C18.4253 8.96011 18.552 7.56001 18.5429 6.16046C18.552 4.75169 18.4281 3.34943 18.1658 1.96396ZM7.69702 8.75421V3.55532L12.4175 6.16046L7.69702 8.75421Z"
                fill="#361863" />
            </svg></a>
        </li>
        <li>
          <a target="_blank" href="https://twitter.com/infithra " rel="noopener noreferrer" aria-label="Twitter"><svg
              xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path
                d="M1.0004 0.981445L6.61235 8.17249L0.964966 14.0191H2.23596L7.18023 8.9003L11.1751 14.0191H15.5003L9.57263 6.42358L14.8292 0.981445H13.5582L9.00474 5.69576L5.32566 0.981445H1.0004ZM2.8695 1.87866H4.85653L13.6309 13.1218H11.6439L2.8695 1.87866Z"
                fill="#361863" />
            </svg></a>
        </li>
      </ul>
    </div>

    <div class="footerLogodivAll">
      <a routerLink="/">
        <div class="headerltr">
          <img src="../../assets/images/infinthra-whitetext-logo.svg" alt="">
        </div>
        <div class="headerrtl">
          <img src="../../assets/images/footer-bottom-logo.svg" alt="">
        </div>
      </a>

      <div class="subScribeLetterDiv">
        <h3>{{ "footer.subscribe.heading" | translate }}</h3>
        <div class="subScrbeLetterDivBgWhite" dir="ltr">

          <form *ngIf="isLargeScreen" [formGroup]="form" name="footerForm" (ngSubmit)="handleSubmit($event)">
            <input type="text" formControlName="honeypot" tabindex="-1" autocomplete="off" aria-hidden="true"
              style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;" />
            <input name="email" type="text" placeholder="{{ 'footer.subscribe.placeholder' | translate }}"
              formControlName="email" />
            <button [type]="this.form.valid ? 'submit' : 'button'" aria-label="label" (click)="showToast()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M3.99959 12.7192L18.1663 12.7192" stroke="white" stroke-width="1.66667"
                  stroke-linecap="round" />
                <path d="M12.8807 18.8379L19 12.7186L12.9053 6.62385" stroke="white" stroke-width="1.66667"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </form>

          <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
            <small class="error">{{ getErrorMessage("email") }}</small>
          </div>
        </div>
      </div>

      <!-- Success Popup Modal -->
      <div class="custom-modal" *ngIf="showSuccessModal">

        <div class="custom-modal-content">
          <img src="../../assets/images/footer-success.svg" alt="Success" class="success-icon" />
          <div class="modal-text">
            <h2>{{ "footer.subscribe.successModal.title" | translate }}</h2>
            <p class="subcontent">{{ "footer.subscribe.successModal.message" | translate }}</p>
          </div>
        </div>
      </div>

      <div class="languagSocialIconDiv">
        <div class="languageDropDownDiv" dir="ltr">
          <div class="dropdown-hover">
            <button class="dropdown-toggle">
              {{ lang == "ar" ? "AR" : "EN" }}

              <svg class="dropSvg" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                fill="none">
                <path d="M3.39408 6.74166L7.63672 10.9843L11.8794 6.74166" stroke="white" stroke-width="1.4"
                  stroke-linecap="round" />
              </svg>
            </button>
            <ul class="dropdown-menu-hover">
              <li>
                <a class="dropdown-item" (click)="setLang('en')" [ngClass]="lang == 'en' ? 'highlight' : ''">EN</a>
              </li>
              <li>
                <a class="dropdown-item" (click)="setLang('ar')" [ngClass]="lang == 'ar' ? 'highlight' : ''">AR</a>
              </li>
            </ul>
          </div>
        </div>
        <ul class="socialMediaNav" dir="ltr">
          <li>
            <a target="_blank" href="https://www.facebook.com/infithra" rel="noopener noreferrer"
              aria-label="Facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a>
          </li>
          <li>
            <a target="_blank" href="https://www.instagram.com/infithra " rel="noopener noreferrer"
              aria-label="Instagram"><img alt="img" src="../../assets/images/instagrame-icon.svg" /></a>
          </li>
          <li>
            <a target="_blank" href="https://www.linkedin.com/company/infithra/" rel="noopener noreferrer"
              aria-label="Linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
          </li>
          <li>
            <a target="_blank" href=" https://www.youtube.com/@infithra" rel="noopener noreferrer"
              aria-label="Youtube"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="13" viewBox="0 0 19 13"
                fill="none">
                <path
                  d="M18.1658 1.96396C17.951 1.23303 17.3562 0.659768 16.5901 0.457123C15.1794 0.0957204 9.50854 0.0957205 9.50854 0.0957205C9.50854 0.0957205 3.84841 0.0870511 2.42306 0.457123C1.66091 0.66031 1.06329 1.23303 0.850707 1.96396C0.583277 3.34943 0.45041 4.75169 0.45663 6.16046C0.453803 7.56001 0.586104 8.96011 0.850707 10.3369C1.06329 11.0678 1.66091 11.6411 2.42306 11.847C3.83371 12.2084 9.50854 12.2084 9.50854 12.2084C9.50854 12.2084 15.1653 12.2084 16.5901 11.847C17.3562 11.6411 17.951 11.0684 18.1658 10.3369C18.4253 8.96011 18.552 7.56001 18.5429 6.16046C18.552 4.75169 18.4281 3.34943 18.1658 1.96396ZM7.69702 8.75421V3.55532L12.4175 6.16046L7.69702 8.75421Z"
                  fill="#361863" />
              </svg></a>
          </li>
          <li>
            <a target="_blank" href="https://twitter.com/infithra" rel="noopener noreferrer" aria-label="Twitter"><svg
                xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                <path
                  d="M1.0004 0.981445L6.61235 8.17249L0.964966 14.0191H2.23596L7.18023 8.9003L11.1751 14.0191H15.5003L9.57263 6.42358L14.8292 0.981445H13.5582L9.00474 5.69576L5.32566 0.981445H1.0004ZM2.8695 1.87866H4.85653L13.6309 13.1218H11.6439L2.8695 1.87866Z"
                  fill="#361863" />
              </svg></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="footerLinkRow">
      <div class="linkDivall">
        <h3>{{ "footer.links.products.title" | translate }}</h3>
        <ul>
          <li>
            <a routerLink="/core-hr">{{
              "footer.links.products.items.coreHR" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/employee-management">{{
              "footer.links.products.items.employee" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/payroll-management">{{
              "footer.links.products.items.payroll" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/leave-management">{{
              "footer.links.products.items.leave" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/attendance-management">{{
              "footer.links.products.items.timeAttendance" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/people-analytics">{{
              "footer.links.products.items.peopleAnalytics" | translate
              }}</a>
          </li>
           <li>
            <a class="coming-soon-hover" routerLink="/">{{ "footer.links.products.items.performance" | translate
              }}
              <!-- <sup>
                {{
                "footer.links.products.items.performanceSup" | translate
                }}</sup> -->
                </a>
          </li>
          <li>
            <a class="coming-soon-hover" routerLink="/">{{ "footer.links.products.items.recruitment" | translate
              }}<sup>
                {{
                "footer.links.products.items.recruitmentSup" | translate
                }}</sup></a>
          </li>
         
        </ul>
      </div>

      <div class="linkDivall resourseSpace">
        <h3>{{ "footer.links.resources.title" | translate }}</h3>
        <ul>
          <!-- <li><a [routerLink]="['/resources']">{{ 'footer.links.resources.items.allResources' | translate }}</a></li> FOR FUTURE USE -->
          <li>
            <a routerLink="/blog">{{
              "footer.links.resources.items.blogs" | translate
              }}</a>
          </li>
          <!-- <li><a [routerLink]="['/client-stories']">{{ 'footer.links.resources.items.clientStories' | translate }}</a></li> FOR FUTURE USE -->
          <!-- <li><a [routerLink]="['/product-demo']">{{ 'footer.links.resources.items.productTours' | translate }}</a></li> FOR FUTURE USE-->
          <li>
            <a routerLink="/hr-glossary">{{
              "footer.links.resources.items.hrGlossary" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/gratuity-calculator">{{
              "footer.links.resources.items.gratuitycalculator" | translate
              }}</a>
          </li>
          <!-- <li>
            <a routerLink="/resources/hr-templates">{{
              "footer.links.resources.items.hrTemplates" | translate
              }}</a>
          </li> -->
          <li>
            <a routerLink="/faq">{{
              "footer.links.resources.items.faq" | translate
              }}</a>
          </li>
          <!-- <li><a [routerLink]="['/help-center']">{{ 'footer.links.resources.items.helpCenter' | translate }}</a></li> FOR FUTURE USE -->
        </ul>
      </div>

      <div class="linkDivall discoverSpace">
        <h3>{{ "footer.links.platform.title" | translate }}</h3>
        <ul>
          <li>
            <a (click)="navigateToExternal($event)">{{
              "footer.links.platform.items.login" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/demo" onclick="sessionStorage.setItem('previous_page', 'footer')">{{
              "footer.links.platform.items.scheduleDemo" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/product-tour" onclick="sessionStorage.setItem('previous_page', 'footer')">{{
              "footer.links.platform.items.productTour" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/use-cases">{{
              "footer.links.platform.items.useCases" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/integrations">{{
              "footer.links.platform.items.integrations" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/pricing">{{
              "footer.links.platform.items.pricing" | translate
              }}</a>
          </li>
        </ul>
      </div>

      <div class="linkDivall platFormSpace">
        <h3>{{ "footer.links.company.title" | translate }}</h3>
        <ul>
          <li>
            <a routerLink="/about-us">{{
              "footer.links.company.items.aboutUs" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/contact-us" onclick="sessionStorage.setItem('previous_page', 'footer')">{{
              "footer.links.company.items.contactUs" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/partner-program">{{
              "footer.links.company.items.partnersprogram" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/newsroom">{{
              "footer.links.company.items.newsroom" | translate
              }}</a>
          </li>
          <li>
            <a routerLink="/ai-information">{{
              "footer.links.company.items.aiInformation" | translate
              }}</a>
          </li>
          <!-- <li>
            <a routerLink="/legal">{{
              "footer.links.company.items.legal" | translate
              }}</a>
          </li> -->
          <!-- <li>
            <a routerLink="/careers">Careers</a>
          </li> -->
          <!-- <li><a>{{ 'footer.links.company.items.newsroom' | translate }}</a></li> FOR FUTURE USE -->
        </ul>
      </div>

      <div class="linkDivall">
        <h3>{{ "footer.links.mobileApp.title" | translate }}</h3>
        <div class="contactListWrapper" [dir]="lang === 'ar' ? 'rtl' : 'ltr'">
        <ul class="contactList">
            <li>
              <img src="../../assets/images/sms.svg" alt="email" loading="lazy" />
              <a href="mailto:sales@infithra.com">sales&#64;infithra.com</a>
            </li>
            <li>
              <img src="../../assets/images/call.svg" alt="phone" loading="lazy" />
              <a href="tel:+97144551010" dir="ltr">{{ "footer.links.mobileApp.phone1" | translate }}</a>
            </li>
            <li>
              <img src="../../assets/images/call.svg" alt="phone" loading="lazy" />
              <a href="tel:+97165483312" dir="ltr">{{ "footer.links.mobileApp.phone2" | translate }}</a>
            </li>
          </ul>
        </div>
        <div class="appGooleStoreBtn">
          <a href="https://play.google.com/store/apps/details?id=com.kpi.infithraESS" target="_blank">
            <button aria-label="google-play">
              <img class="iconsize" alt="google play" [src]="
                  'footer.links.mobileApp.buttonImg.googlePlay' | translate
                " loading="lazy" />
            </button>
          </a>
          <a href="https://apps.apple.com/ae/app/infithra/id6503617676" target="_blank">
            <button aria-label="app-store">
              <img class="iconsize" alt="app store" [src]="'footer.links.mobileApp.buttonImg.appStore' | translate" loading="lazy" />
            </button>
          </a>
        </div>
      </div>
    </div>

    <div class="mobileFooterLink">
      <div class="accordion" id="accordionExample10">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              {{ "footer.links.products.title" | translate }}
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample10">
            <div class="accordion-body">
              <div class="linkDivall">
                <ul>
                  <li>
                    <a routerLink="/core-hr">{{
                      "footer.links.products.items.coreHR" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/employee-management">{{
                      "footer.links.products.items.employee" | translate
                      }}</a>
                  </li>
                  <li>
                    <a a routerLink="/payroll-management">{{
                      "footer.links.products.items.payroll" | translate
                      }}</a>
                  </li>
                  <li>
                    <a a routerLink="/leave-management">{{
                      "footer.links.products.items.leave" | translate
                      }}</a>
                  </li>
                  <li>
                    <a a routerLink="/attendance-management">{{
                      "footer.links.products.items.timeAttendance" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/attendance-management">{{
                      "footer.links.products.items.peopleAnalytics" | translate
                      }}</a>
                  </li>
                   <li>
                    <a routerLink="/">{{ "footer.links.products.items.performance" | translate
                      }}
                      <!-- <sup style="top: -1px">
                        {{
                        "footer.links.products.items.performanceSup"
                        | translate
                        }}</sup> -->
                        </a>
                  </li>
                  <li>
                    <a routerLink="/">{{ "footer.links.products.items.recruitment" | translate
                      }}<sup style="top: -2px">
                        {{
                        "footer.links.products.items.recruitmentSup"
                        | translate
                        }}</sup></a>
                  </li>
                 
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              {{ "footer.links.resources.title" | translate }}
            </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample10">
            <div class="accordion-body">
              <div class="linkDivall">
                <ul>
                  <!-- <li><a [routerLink]="['/resources']">{{ 'footer.links.resources.items.allResources' | translate }}</a></li> FOR FUTURE USE -->
                  <li>
                    <a routerLink="/blog">{{
                      "footer.links.resources.items.blogs" | translate
                      }}</a>
                  </li>
                  <!-- <li><a [routerLink]="['/client-stories']">{{ 'footer.links.resources.items.clientStories' | translate }}</a></li> FOR FUTURE USE -->
                  <!-- <li><a [routerLink]="['/product-demo']">{{ 'footer.links.resources.items.productTours' | translate }}</a></li> FOR FUTURE USE-->
                  <li>
                    <a routerLink="/hr-glossary">{{
                      "footer.links.resources.items.hrGlossary" | translate
                      }}</a>
                  </li>
                   <li>
                    <a routerLink="/gratuity-calculator">{{
                      "footer.links.resources.items.gratuitycalculator" | translate
                      }}</a>
                  </li>
                  <!-- <li>
                    <a routerLink="/resources/hr-templates">{{
                      "footer.links.resources.items.hrTemplates" | translate
                      }}</a>
                  </li> -->
                  <li>
                    <a routerLink="/faq">{{
                      "footer.links.resources.items.faq" | translate
                      }}</a>
                  </li>
                  <!-- <li><a [routerLink]="['/help-center']">{{ 'footer.links.resources.items.helpCenter' | translate }}</a></li> FOR FUTURE USE -->
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              {{ "footer.links.company.title" | translate }}
            </button>
          </h2>
          <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
            data-bs-parent="#accordionExample10">
            <div class="accordion-body">
              <div class="linkDivall">
                <ul>
                  <li>
                    <a routerLink="/about-us">{{
                      "footer.links.company.items.aboutUs" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/contact-us" onclick="sessionStorage.setItem('previous_page', 'footer')">{{
                      "footer.links.company.items.contactUs" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/partner-program">{{
                      "footer.links.company.items.partnersprogram" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/newsroom">{{
                      "footer.links.company.items.newsroom" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/ai-information">{{
                      "footer.links.company.items.aiInformation" | translate
                      }}</a>
                  </li>
                  <!-- <li>
                    <a routerLink="/legal">{{
                      "footer.links.company.items.legal" | translate
                      }}</a>
                  </li> -->
                  <!-- <li>
                    <a routerLink="/careers">Careers</a>
                  </li> -->
                  <!-- <li><a>{{ 'footer.links.company.items.newsroom' | translate }}</a></li> FOR FUTURE USE -->
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              {{ "footer.links.platform.title" | translate }}
            </button>
          </h2>
          <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
            data-bs-parent="#accordionExample10">
            <div class="accordion-body">
              <div class="linkDivall">
                <ul>
                  <li>
                    <a href="https://app.infithra.com/auth/login">{{
                      "footer.links.platform.items.login" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/demo" onclick="sessionStorage.setItem('previous_page', 'footer')">{{
                      "footer.links.platform.items.scheduleDemo" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/product-tour" onclick="sessionStorage.setItem('previous_page', 'footer')">{{
                      "footer.links.platform.items.productTour" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/use-cases">{{
                      "footer.links.platform.items.useCases" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/integrations">{{
                      "footer.links.platform.items.integrations" | translate
                      }}</a>
                  </li>
                  <li>
                    <a routerLink="/pricing">{{
                      "footer.links.platform.items.pricing" | translate
                      }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="linkDivallMobile">
        <h3>{{ "footer.links.mobileApp.title" | translate }}</h3>
        <div class="contactListWrapper" [dir]="lang === 'ar' ? 'rtl' : 'ltr'">
          <ul class="contactList">
            <li>
              <img src="../../assets/images/sms.svg" alt="email" loading="lazy" />
              <a href="mailto:sales@infithra.com" dir="ltr">sales&#64;infithra.com</a>
            </li>
            <li>
              <img src="../../assets/images/call.svg" alt="phone" loading="lazy" />
              <a href="tel:+97144551010" dir="ltr">{{ "footer.links.mobileApp.phone1" | translate }}</a>
            </li>
            <li>
              <img src="../../assets/images/call.svg" alt="phone" loading="lazy" />
              <a href="tel:+97165483312" dir="ltr">{{ "footer.links.mobileApp.phone2" | translate }}</a>
            </li>
          </ul>
        </div>
        <div class="appGooleStoreBtn">
          <button class="gplayBtn" aria-label="play-button" (click)="openPlayStore()">
            <img [src]="'footer.links.mobileApp.buttonImg.googlePlay' | translate" loading="lazy" alt="play-button" />
          </button>
          <button aria-label="label" (click)="openAppleStore()">
            <img [src]="'footer.links.mobileApp.buttonImg.appStore' | translate" loading="lazy" alt="app-store" style="width: 100%; height: 49px;" />
          </button>
        </div>
      </div>
    </div>

    <div class="logoDivMainallEndFooter" dir="ltr">
      <img alt="infithra-iso-27001-certification" src="../../assets/images/footer-certification-logo.svg"
        loading="lazy" />

      <img alt="infithra-soc-2-certification" src="../../assets/images/SOC-2-Certificate-Logo.svg" loading="lazy"
        style="width: 71px;" />


    </div>
    <ul class="footerEndLink" dir="ltr">
      <li>
        <a routerLink="/privacy-policy">{{ "footer.endLinks.privacyPolicy" | translate }}</a>
      </li>
      <li>
        <a routerLink="/security">{{ "footer.endLinks.Securitydataprotection" | translate }}</a>
      </li>
      <li>
        <a routerLink="/legal">{{ "footer.endLinks.Legalresources" | translate }}</a>
      </li>
      <!-- <li>
        <a routerLink="/copyright">{{ "footer.endLinks.Copyright" | translate }}</a>
      </li> -->
    </ul>
    <p class="copyRightPara" [innerHTML]="dynamicCopyright"></p>
  </div>
</footer>


<!-- <div class="toast-container_wrapper" [class.activeToast]="toastState">
  <div>
    <h3>success</h3>
    <p>Form submitted successfully</p>
  </div>
  <div class="closeBtn" (click)="closeToast()">x</div>
</div>
<div class="toast-container_wrapper_error" [class.activeToast]="errorState">
  <div>
    <h3>Error</h3>
    <p>Please fill the form before submitting</p>
  </div>
  <div class="closeBtn" (click)="closeToast()">x</div>
</div> -->